// @ts-ignore
import { Methods, ContractNames } from "@airdao/airdao-bond";
import { BigNumber } from 'ethers';
import {ethers} from 'ethers';

type MarketSettings = {
  contracts: any;
  contractName: ContractNames.FixedTermFPA;
  payoutToken: string;
  payoutDecimals: number;
  payoutPrice: number; 
  quoteToken: string
  quoteDecimals: number;
  quotePrice: number;
  capacityInQuote: boolean;
  capacity: BigNumber;
  depositInterval: number;
  vesting: number;
  start: number;
  duration: number;
  discount: number;
  discountTierManager: string;
}

export const createMarket = async (contracts: any, type: string, settings: MarketSettings) => {
  if (settings.payoutToken !== ethers.constants.AddressZero) {
    const tx = await Methods.ERC20Approve(
      settings.payoutToken,
      contracts.getContractByName(settings.contractName).address,
      settings.capacity,
      contracts.signerOrProvider,
    );
    await tx.wait();
  }
  console.log(settings);
  return await (
    await Methods.createMarket(
      contracts,
      type,
      settings,
    )
  ).wait();
}